import { useQuery } from '@tanstack/react-query';
import { fetchAttendanceLog } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import AttendanceLogEntry from 'src/models/AttendanceLogEntry';

export default function useAttendanceLog(classId: number, studentUserId: number) {
  return useQuery<AttendanceLogEntry[], ApiError>({
    queryKey: ['attendanceLog', classId, studentUserId],
    queryFn: () => fetchAttendanceLog({ classId, studentUserId }),
  });
}
